module.exports = __webpack_public_path__ + "static/img/推荐.b90e54f0.png";